import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

const ADMIN_EMAILS = ['paolotennis2003@gmail.com', 'studyplannerschedule@gmail.com']
const PIN = '3233'

export function AdminPage({ user }: { user: any }) {
  const navigate = useNavigate()
  const [users, setUsers] = useState<any[]>([])
  const [plans, setPlans] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [pinOk, setPinOk] = useState(false)
  const [pinInput, setPinInput] = useState('')
  const [pinError, setPinError] = useState(false)
  const [affiliates, setAffiliates] = useState<any[]>([])
  const [newAff, setNewAff] = useState({ name: '', email: '', code: '', password: '' })
  const [addingAff, setAddingAff] = useState(false)
  const [activeTab, setActiveTab] = useState<'overview'|'users'|'affiliates'>('overview')

  useEffect(() => {
    if (!user) { navigate('/'); return }
    if (!ADMIN_EMAILS.includes(user.email)) { navigate('/'); return }
    loadData()
  }, [user?.id])

  const loadData = async () => {
    setLoading(true)
    const { data: u } = await supabase.from('users').select('*').order('created_at', { ascending: false })
    const { data: p } = await supabase.from('plans').select('*').order('created_at', { ascending: false })
    const { data: a } = await supabase.from('affiliates').select('*').order('created_at', { ascending: false })
    setUsers(u || [])
    setPlans(p || [])
    setAffiliates(a || [])
    setLoading(false)
  }

  const createAffiliate = async () => {
    if (!newAff.name || !newAff.code || !newAff.password) return alert('Compila tutti i campi')
    const { error } = await supabase.from('affiliates').insert({
      name: newAff.name, email: newAff.email,
      code: newAff.code.toLowerCase().replace(/\s/g, ''),
      password: newAff.password, commission_rate: 30
    })
    if (error) alert('Errore: ' + error.message)
    else { setNewAff({ name: '', email: '', code: '', password: '' }); setAddingAff(false); loadData() }
  }

  const deleteAffiliate = async (id: string) => {
    if (!window.confirm('Eliminare questo affiliato?')) return
    await supabase.from('affiliates').delete().eq('id', id)
    loadData()
  }

  const exportGrowth = () => {
    // Raggruppa utenti per giorno
    const byDay: Record<string, number> = {}
    users.forEach(u => {
      if (!u.created_at) return
      const day = new Date(u.created_at).toLocaleDateString('it-IT')
      byDay[day] = (byDay[day] || 0) + 1
    })
    // Crea lista cumulativa
    const sorted = Object.entries(byDay).sort((a, b) => new Date(a[0].split('/').reverse().join('-')).getTime() - new Date(b[0].split('/').reverse().join('-')).getTime())
    let cumulative = 0
    const rows = sorted.map(([day, count]) => {
      cumulative += count
      return [day, count, cumulative]
    })
    const headers = ['Data', 'Nuovi utenti', 'Totale cumulativo']
    const csv = [headers, ...rows].map(r => r.map(v => '"' + String(v).replace(/"/g, '""') + '"').join(',')).join('\n')
    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a'); a.href = url
    a.download = 'crescita-utenti-' + new Date().toISOString().split('T')[0] + '.csv'; a.click()
    URL.revokeObjectURL(url)
  }

  const exportUsers = () => {
    const headers = ['Email', 'Premium', 'Scadenza', 'Registrato', 'Piani salvati', 'Stripe ID']
    const rows = users.map(u => [
      u.email || '',
      u.is_premium ? 'SI' : 'NO',
      u.premium_expires_at ? new Date(u.premium_expires_at).toLocaleDateString('it-IT') : '',
      u.created_at ? new Date(u.created_at).toLocaleDateString('it-IT') : '',
      plans.filter(p => p.user_id === u.id).length,
      u.stripe_customer_id || ''
    ])
    const csv = [headers, ...rows].map(r => r.map(v => '"' + String(v).replace(/"/g, '""') + '"').join(',')).join('\n')
    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a'); a.href = url
    a.download = 'utenti-' + new Date().toISOString().split('T')[0] + '.csv'; a.click()
    URL.revokeObjectURL(url)
  }

  if (!pinOk) return (
    <div style={{ minHeight: '100vh', backgroundColor: '#111827', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ backgroundColor: 'white', borderRadius: 20, padding: 40, maxWidth: 320, width: '90%', textAlign: 'center' }}>
        <div style={{ fontSize: 36, marginBottom: 12 }}>🔐</div>
        <h2 style={{ margin: '0 0 8px', fontSize: 20, fontWeight: 800 }}>Admin Access</h2>
        <p style={{ color: '#6B7280', fontSize: 14, marginBottom: 24 }}>Inserisci il PIN per accedere</p>
        <input type="password" value={pinInput} onChange={e => setPinInput(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') { if (pinInput === PIN) setPinOk(true); else setPinError(true) } }}
          placeholder="PIN" style={{ width: '100%', padding: '12px', borderRadius: 10, border: pinError ? '2px solid #EF4444' : '1px solid #E5E7EB', fontSize: 18, textAlign: 'center', letterSpacing: 8, boxSizing: 'border-box' as const }} />
        {pinError && <p style={{ color: '#EF4444', fontSize: 13, marginTop: 8 }}>PIN errato</p>}
        <button onClick={() => { if (pinInput === PIN) setPinOk(true); else setPinError(true) }}
          style={{ width: '100%', marginTop: 16, padding: '12px', backgroundColor: '#111827', color: 'white', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 700, cursor: 'pointer' }}>
          Accedi
        </button>
      </div>
    </div>
  )

  if (loading) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Caricamento...</div>

  // Calcoli statistiche
  const now = new Date()
  const premium = users.filter(u => u.is_premium)
  const trial = premium.filter(u => u.premium_expires_at && new Date(u.premium_expires_at) > now && !u.stripe_customer_id)
  const paying = premium.filter(u => u.stripe_customer_id)
  const mrr = paying.length * 2.99
  const churnRisk = users.filter(u => {
    if (!u.is_premium || !u.premium_expires_at) return false
    if (u.stripe_customer_id) return false // ha già pagato, si rinnova auto
    const exp = new Date(u.premium_expires_at)
    const diff = (exp.getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
    return diff <= 7 && diff >= 0
  })
  const newUsersThisWeek = users.filter(u => {
    if (!u.created_at) return false
    const diff = (now.getTime() - new Date(u.created_at).getTime()) / (1000 * 60 * 60 * 24)
    return diff <= 7
  })
  const conversionRate = users.length > 0 ? Math.round((premium.length / users.length) * 100) : 0
  const totalPlans = plans.length
  const avgPlansPerUser = users.length > 0 ? (totalPlans / users.length).toFixed(1) : '0'

  // Crescita utenti per settimana (ultime 4 settimane)
  const weeklyGrowth = [0,1,2,3].map(w => {
    const start = new Date(now); start.setDate(start.getDate() - (w+1)*7)
    const end = new Date(now); end.setDate(end.getDate() - w*7)
    return users.filter(u => u.created_at && new Date(u.created_at) >= start && new Date(u.created_at) < end).length
  }).reverse()

  const cardStyle = { backgroundColor: 'white', borderRadius: 16, padding: '20px 24px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }
  const tabStyle = (active: boolean) => ({ padding: '8px 20px', borderRadius: 8, border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 14, backgroundColor: active ? '#111827' : 'transparent', color: active ? 'white' : '#6B7280' })

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F9FAFB' }}>
      {/* Header */}
      <div style={{ backgroundColor: '#111827', padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ color: 'white', fontWeight: 800, fontSize: 18 }}>⚙️ Admin Dashboard</span>
          <div style={{ display: 'flex', gap: 4 }}>
            <button onClick={() => setActiveTab('overview')} style={tabStyle(activeTab === 'overview')}>Overview</button>
            <button onClick={() => setActiveTab('users')} style={tabStyle(activeTab === 'users')}>Utenti</button>
            <button onClick={() => setActiveTab('affiliates')} style={tabStyle(activeTab === 'affiliates')}>Affiliati</button>
          </div>
        </div>
        <button onClick={() => navigate('/')} style={{ color: 'white', backgroundColor: 'transparent', border: '1px solid rgba(255,255,255,0.3)', borderRadius: 8, padding: '6px 14px', cursor: 'pointer', fontSize: 13 }}>← App</button>
      </div>

      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '24px 16px' }}>

        {activeTab === 'overview' && (
          <>
            {/* KPI Cards */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 16, marginBottom: 24 }}>
              {[
                { label: 'Utenti totali', value: users.length, icon: '👥', color: '#1c3fff' },
                { label: 'Premium attivi', value: premium.length, icon: '✦', color: '#D97706' },
                { label: 'In trial', value: trial.length, icon: '⏳', color: '#6B7280' },
                { label: 'Paganti reali', value: paying.length, icon: '💳', color: '#10B981' },
                { label: 'MRR', value: '€' + mrr.toFixed(2), icon: '💰', color: '#8B5CF6' },
                { label: 'Conversione', value: conversionRate + '%', icon: '📈', color: '#F59E0B' },
                { label: 'Nuovi (7gg)', value: newUsersThisWeek.length, icon: '🆕', color: '#3B82F6' },
                { label: 'Piani creati', value: totalPlans, icon: '📅', color: '#EC4899' },
              ].map(k => (
                <div key={k.label} style={{ ...cardStyle, borderLeft: '4px solid ' + k.color }}>
                  <div style={{ fontSize: 22, marginBottom: 4 }}>{k.icon}</div>
                  <div style={{ fontSize: 24, fontWeight: 800, color: k.color }}>{k.value}</div>
                  <div style={{ fontSize: 12, color: '#6B7280', marginTop: 2 }}>{k.label}</div>
                </div>
              ))}
            </div>

            {/* Crescita settimanale */}
            <div style={{ ...cardStyle, marginBottom: 24 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>📈 Crescita utenti (ultime 4 settimane)</h3>
                <button onClick={exportGrowth} style={{ backgroundColor: '#1c3fff', color: 'white', border: 'none', borderRadius: 8, padding: '6px 14px', cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>📥 Esporta crescita all time</button>
              </div>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: 16, height: 80 }}>
                {weeklyGrowth.map((v, i) => {
                  const max = Math.max(...weeklyGrowth, 1)
                  const labels = ['-4 sett', '-3 sett', '-2 sett', 'Questa sett']
                  return (
                    <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                      <span style={{ fontSize: 12, fontWeight: 700, color: '#111827' }}>{v}</span>
                      <div style={{ width: '100%', backgroundColor: '#1c3fff', borderRadius: '4px 4px 0 0', height: Math.max(4, (v / max) * 60) }} />
                      <span style={{ fontSize: 10, color: '#9CA3AF' }}>{labels[i]}</span>
                    </div>
                  )
                })}
              </div>
            </div>

            {/* Trial a rischio */}
            {churnRisk.length > 0 && (
              <div style={{ ...cardStyle, marginBottom: 24, borderLeft: '4px solid #EF4444' }}>
                <h3 style={{ margin: '0 0 12px', fontSize: 16, fontWeight: 700, color: '#EF4444' }}>⚠️ Trial in scadenza (prossimi 7 giorni)</h3>
                {churnRisk.map(u => (
                  <div key={u.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #F3F4F6', fontSize: 14 }}>
                    <span>{u.email}</span>
                    <span style={{ color: '#EF4444', fontWeight: 600 }}>Scade: {new Date(u.premium_expires_at).toLocaleDateString('it-IT')}</span>
                  </div>
                ))}
              </div>
            )}

            {/* Metriche aggiuntive */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
              <div style={cardStyle}>
                <h3 style={{ margin: '0 0 12px', fontSize: 15, fontWeight: 700 }}>📊 Engagement</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14 }}>
                    <span style={{ color: '#6B7280' }}>Piani per utente (media)</span>
                    <strong>{avgPlansPerUser}</strong>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14 }}>
                    <span style={{ color: '#6B7280' }}>Utenti con almeno 1 piano</span>
                    <strong>{users.filter(u => plans.some(p => p.user_id === u.id)).length}</strong>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14 }}>
                    <span style={{ color: '#6B7280' }}>Utenti senza piani</span>
                    <strong>{users.filter(u => !plans.some(p => p.user_id === u.id)).length}</strong>
                  </div>
                </div>
              </div>
              <div style={cardStyle}>
                <h3 style={{ margin: '0 0 12px', fontSize: 15, fontWeight: 700 }}>💰 Ricavi stimati</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14 }}>
                    <span style={{ color: '#6B7280' }}>MRR attuale</span>
                    <strong style={{ color: '#10B981' }}>€{mrr.toFixed(2)}</strong>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14 }}>
                    <span style={{ color: '#6B7280' }}>ARR stimato</span>
                    <strong style={{ color: '#10B981' }}>€{(mrr * 12).toFixed(2)}</strong>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14 }}>
                    <span style={{ color: '#6B7280' }}>Per utente (ARPU)</span>
                    <strong>€{paying.length > 0 ? (mrr / paying.length).toFixed(2) : '0.00'}</strong>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        {activeTab === 'users' && (
          <div style={cardStyle}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>👥 Lista utenti ({users.length})</h3>
              <button onClick={exportUsers} style={{ backgroundColor: '#1c3fff', color: 'white', border: 'none', borderRadius: 8, padding: '8px 16px', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>📥 Esporta CSV</button>
            </div>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ backgroundColor: '#F9FAFB' }}>
                    {['Email', 'Premium', 'Tipo', 'Scadenza', 'Piani', 'Registrato'].map(h => (
                      <th key={h} style={{ padding: '10px 12px', textAlign: 'left', color: '#9CA3AF', fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1 }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {users.map(u => {
                    const userPlans = plans.filter(p => p.user_id === u.id).length
                    const isPaying = u.stripe_customer_id && u.is_premium
                    const isTrial = u.is_premium && !isPaying
                    return (
                      <tr key={u.id} style={{ borderBottom: '1px solid #F3F4F6' }}>
                        <td style={{ padding: '10px 12px' }}>{u.email || '—'}</td>
                        <td style={{ padding: '10px 12px' }}>
                          {u.is_premium ? <span style={{ color: '#D97706', fontWeight: 700 }}>✦ SI</span> : <span style={{ color: '#9CA3AF' }}>NO</span>}
                        </td>
                        <td style={{ padding: '10px 12px' }}>
                          {isPaying ? <span style={{ backgroundColor: '#D1FAE5', color: '#065F46', padding: '2px 8px', borderRadius: 20, fontSize: 11, fontWeight: 600 }}>Pagante</span>
                          : isTrial ? <span style={{ backgroundColor: '#FEF3C7', color: '#92400E', padding: '2px 8px', borderRadius: 20, fontSize: 11, fontWeight: 600 }}>Trial</span>
                          : <span style={{ backgroundColor: '#F3F4F6', color: '#6B7280', padding: '2px 8px', borderRadius: 20, fontSize: 11 }}>Free</span>}
                        </td>
                        <td style={{ padding: '10px 12px', color: '#6B7280' }}>
                          {u.premium_expires_at ? new Date(u.premium_expires_at).toLocaleDateString('it-IT') : '—'}
                        </td>
                        <td style={{ padding: '10px 12px' }}>
                          <span style={{ backgroundColor: '#EFF6FF', color: '#1c3fff', padding: '2px 8px', borderRadius: 20, fontSize: 11, fontWeight: 600 }}>{userPlans} piani</span>
                        </td>
                        <td style={{ padding: '10px 12px', color: '#6B7280' }}>
                          {u.created_at ? new Date(u.created_at).toLocaleDateString('it-IT') : '—'}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {activeTab === 'affiliates' && (
          <div>
            <div style={{ ...cardStyle, marginBottom: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>🤝 Affiliati ({affiliates.length})</h3>
                <button onClick={() => setAddingAff(!addingAff)} style={{ backgroundColor: '#111827', color: 'white', border: 'none', borderRadius: 8, padding: '8px 16px', cursor: 'pointer', fontSize: 13, fontWeight: 600 }}>+ Nuovo affiliato</button>
              </div>

              {addingAff && (
                <div style={{ backgroundColor: '#F9FAFB', borderRadius: 12, padding: 16, marginBottom: 16 }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
                    {[['Nome', 'name'], ['Email', 'email'], ['Codice', 'code'], ['Password', 'password']].map(([label, key]) => (
                      <div key={key}>
                        <label style={{ fontSize: 12, color: '#6B7280', display: 'block', marginBottom: 4 }}>{label}</label>
                        <input value={(newAff as any)[key]} onChange={e => setNewAff({ ...newAff, [key]: e.target.value })}
                          style={{ width: '100%', border: '1px solid #E5E7EB', borderRadius: 8, padding: '8px 12px', fontSize: 14, boxSizing: 'border-box' as const }} />
                      </div>
                    ))}
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button onClick={createAffiliate} style={{ backgroundColor: '#1c3fff', color: 'white', border: 'none', borderRadius: 8, padding: '8px 16px', cursor: 'pointer', fontWeight: 600 }}>Crea</button>
                    <button onClick={() => setAddingAff(false)} style={{ backgroundColor: '#F3F4F6', color: '#374151', border: 'none', borderRadius: 8, padding: '8px 16px', cursor: 'pointer' }}>Annulla</button>
                  </div>
                </div>
              )}

              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                  <thead>
                    <tr style={{ backgroundColor: '#F9FAFB' }}>
                      {['Nome', 'Codice', 'Password', 'Click', 'Conv.', 'Guadagni', ''].map(h => (
                        <th key={h} style={{ padding: '10px 12px', textAlign: 'left', color: '#9CA3AF', fontSize: 11, fontWeight: 700, textTransform: 'uppercase' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {affiliates.map(a => (
                      <tr key={a.id} style={{ borderBottom: '1px solid #F3F4F6' }}>
                        <td style={{ padding: '10px 12px' }}><div style={{ fontWeight: 600 }}>{a.name}</div><div style={{ color: '#9CA3AF', fontSize: 11 }}>{a.email}</div></td>
                        <td style={{ padding: '10px 12px' }}><code style={{ backgroundColor: '#F3F4F6', padding: '2px 6px', borderRadius: 4 }}>{a.code}</code></td>
                        <td style={{ padding: '10px 12px', color: '#6B7280' }}>{a.password || '—'}</td>
                        <td style={{ padding: '10px 12px' }}>{a.clicks}</td>
                        <td style={{ padding: '10px 12px' }}>{a.conversions}</td>
                        <td style={{ padding: '10px 12px', color: '#10B981', fontWeight: 600 }}>€{Number(a.earnings || 0).toFixed(2)}</td>
                        <td style={{ padding: '10px 12px' }}>
                          <button onClick={() => deleteAffiliate(a.id)} style={{ backgroundColor: '#FEE2E2', color: '#EF4444', border: 'none', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', fontSize: 12 }}>🗑</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
